module.exports = __webpack_public_path__ + "61c987ed7dff1286aee1e1d5166eff40.pdf";